import React from "react";
import "./EmptyState.css";

interface Props { icon: React.ReactNode; title: string; description: string; action?: React.ReactNode; }
export default function EmptyState({ icon, title, description, action }: Props) {
  return <div className="navo-empty-state">
    <div className="navo-empty-state__icon" aria-hidden="true">{icon}</div>
    <h3>{title}</h3><p>{description}</p>
    {action && <div className="navo-empty-state__action">{action}</div>}
  </div>;
}
